import { createContext, useContext, useEffect, useState } from "react";
import {
  saveDataInStorage,
  getDataInStorage,
  removeDataInStorage,
} from "./utils/manageLocalStorage";
import checkTimeStampLoggedUser from "./utils/checkTimeStampLoggedUser";
import GETCenope from "./helpers/permisos/GETCenope";
import POSTRefreshToken from "./helpers/autenticacion/POSTRefreshToken";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [loggedUser, setLoggedUser] = useState({});
  const [cenope, setCenope] = useState(null);
  const [loading, setLoading] = useState(true);
  const [openMenu, setOpenMenu] = useState(false);

  const logout = () => {
    removeDataInStorage("userWMS");
    setLoggedUser({});
    setCenope(null);
  };

  const login = async (userData) => {
    saveDataInStorage("userWMS", userData);
    setLoggedUser(userData);

    const responseCenope = await GETCenope(userData);
    if (responseCenope?.status === 200) {
      setCenope(responseCenope.data);
    }
  };

  // Inicialización de sesión (una sola vez)
  useEffect(() => {
    const initializeAuth = async () => {
      try {
        const storedUser = await getDataInStorage("userWMS");

        if (!storedUser || !storedUser.refreshToken) {
          logout();
          return;
        }

        const isAccessTokenValid = checkTimeStampLoggedUser(
          storedUser.expireDateToken,
        );

        if (isAccessTokenValid) {
          await login(storedUser);
        } else {
          const refreshResult = await POSTRefreshToken(storedUser.refreshToken);
          if (refreshResult?.status === 200 && refreshResult.data) {
            await login(refreshResult.data);
          } else {
            logout();
          }
        }
      } catch (error) {
        console.error("Error en inicialización de autenticación:", error);
        logout();
      } finally {
        setLoading(false);
      }
    };

    initializeAuth();
  }, []);

  return (
    <AuthContext.Provider
      value={{
        loading,
        loggedUser,
        login,
        logout,
        cenope,
        openMenu,
        setOpenMenu,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
